export default {
    props: {
        source: {
            type: Array,
            default: () => {
                return [];
            }
        },
        isReservedForYou: {
            type: Boolean,
            default: false
        }
    },
    name: 'breadcrump',
    data: () => ({
        isDesktop: true
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isDesktop = !(window.innerWidth <= 768);
        });
        vue.isDesktop = !(window.innerWidth <= 768);
    },
    methods: {
        redirectTo(route) {
            window.location = route;
        },
        redirectBack() {
            if (this.source.length > 1) {
                window.location = this.source[this.source.length - 2].route;
            } else {
                history.go(-1);
            }
        }
    }
};
